<template>
  <div class="section-new-order section-full">
    <form-order v-if="step==0" :tableSelected="this.table" :step="this.step" :title="$gettext('Create new order')"/>
<!--     <grid-table v-if="step==1" @pickTable="pickTable" /> -->
   <!--  <grid-staff v-if="step==0" @pickStaff="pickStaff" /> -->
  </div>
</template>

<script>
import FormOrder from '@/components/FormOrder.vue';
import GridTable from '@/components/GridTable.vue';


export default {
  data() {
    return {
      step: 0,
      dialog: false,
      table: 0,
    }
  },
  name: 'NewOrder',
  components: {
    FormOrder,
    GridTable,
  },
  methods: {
    cancelNewOrder() {
      this.$store.commit(TOGGLE_MIXER_MODAL, false);
    },
    pickTable(table) {
      this.table = table;
      this.step++;
    },
  }
};
</script>
